// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as BlacklistPartnerResponseMapper from "../entity-mapper/BlacklistPartnerResponseMapper.bs.js";

var execute = BlacklistPartnerResponseMapper.execute;

var BlacklistPartnerResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var BlacklistPartnerResponseConverter = partial_arg(BlacklistPartnerResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  BlacklistPartnerResponseConverterConfig ,
  BlacklistPartnerResponseConverter ,
  
}
/* BlacklistPartnerResponseConverter Not a pure module */
